// extracted by mini-css-extract-plugin
export default {"desc":"Description_desc__EHSit","desc1":"Description_desc1__SffE6","desc2":"Description_desc2__XU6hs","line":"Description_line__tCu9P"};